// extracted by mini-css-extract-plugin
export default {"Emoji":"bbg_a bhg_i bhg_q bhg_j"};